var map = {
	"./arrow-black.svg": "9fb3",
	"./arrow.svg": "1106",
	"./bp-logo-dark.svg": "4797",
	"./bp-logo.svg": "f3b5",
	"./colorwall.svg": "12c2",
	"./ding.svg": "291a",
	"./home-icon-ext-green.svg": "412d",
	"./home-icon-ext-white.svg": "8b5c",
	"./home-icon-green.svg": "2fd3",
	"./home-icon-int-green.svg": "1143",
	"./home-icon-int-white.svg": "b37a",
	"./home-icon.svg": "c97e",
	"./pinchtap.svg": "b10b",
	"./resultslist.svg": "e603",
	"./shop.svg": "0c03"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";